import React from 'react';
import { Box, makeStyles, Typography, Grid, Divider, Container, Button } from '@material-ui/core';
import Page from 'src/components/Page';
import Hero from './Hero';
import Features from './Features';
import Testimonials from './Testimonials';
import CTA from './CTA';
import FAQS from './FAQS';

import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: {
    align: "center",
    textAlign: "center",
  },
  typography: {
    align: "center",
    textAlign: "center",
  }
}));

const HomeView = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Home"
    >
      <Container maxWidth="md">
      <Grid Container>
        <Grid item> 
          <Box m={10} lineHeight={2}>
            <Typography variant="h2" color="textPrimary" align="center" className={classes.typography} gutterBottom>
              Welcome to Recycling Management System
            </Typography>
            <Box m={3}><Divider></Divider></Box>
            
            <Typography variant="body1" color="textPrimary" align="center" className={classes.typography} paragraph>
              A comprehensive business management platform designed specifically for recycling operations and scrap metal dealers. This powerful system streamlines the entire recycling workflow—from weighbridge operations and purchase transactions to sales management, inventory tracking, and financial reporting across multiple branch locations.
            </Typography>
            
            <Typography variant="body1" color="textPrimary" align="center" className={classes.typography} paragraph>
              The platform features integrated Point-of-Sale (POS) functionality with cash register management, customer account tracking, product pricing controls, expense monitoring, and detailed analytics. Built to handle the unique demands of the recycling industry, it supports multi-branch operations with role-based access control, real-time inventory updates, and comprehensive transaction management for both ferrous and non-ferrous materials, plastics, paper, and e-waste categories.
            </Typography>
            
            <Box m={4}><Divider></Divider></Box>
            
            <Typography variant="h5" color="textSecondary" align="center" className={classes.typography} gutterBottom>
              DEMO APPLICATION NOTICE
            </Typography>
            
            <Typography variant="body2" color="textSecondary" align="center" className={classes.typography} paragraph>
              This is an early release demo application provided for demonstration and evaluation purposes only. Please be aware that the software may contain bugs or incomplete features. Data integrity and functionality cannot be guaranteed in this demo environment. This software is designed for desktop display and has not yet been updated for responsive mobile use.
            </Typography>
            
            <Box mt={3} mb={3} p={2} bgcolor="warning.light" borderRadius={4}>
              <Typography variant="body2" align="center" style={{ color: '#000' }}>
                <strong>⚠️ IMPORTANT:</strong>
              </Typography>
              <Typography variant="body2" align="left" style={{ color: '#000', marginTop: '8px' }}>
                1. After logging in, ensure the till user has an active cash float assigned. Without an active float, no transactions can be processed.
              </Typography>
              <Typography variant="body2" align="left" style={{ color: '#000', marginTop: '8px' }}>
                2. Please view and use the app on a computer or tablet that supports at least 1280px width.
              </Typography>
              <Typography variant="body2" align="left" style={{ color: '#000', marginTop: '8px' }}>
                3. To view any existing data, set the filter dates from 1 NOV 2024.
              </Typography>
            </Box>
            
            <Box mt={3} mb={3}>
              <Divider />
            </Box>
            
            <Typography variant="caption" color="textSecondary" align="center" className={classes.typography} paragraph>
              Copyright © Original Author Anton de Villiers (2021) | Architect & Developer of the Point of Sale System | Developed under antondevilliers.com between 2021 - 2022
            </Typography>
            
            <Box mt={4}>
              <Button
                color="secondary"
                component={RouterLink}
                to="/app"
                variant="contained"
                size="large"
              >
                Proceed to Application
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
      </Container>
      {/* <Hero />
      <Features />
      <Testimonials />
      <CTA />
      <FAQS /> */}
    </Page>
  );
};

export default HomeView;
